var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-player"},[_c('video',{ref:"videoPlayer",staticClass:"video-js video-custom-styling"}),_c('button',{staticClass:"video-player__close",on:{"click":_vm.closeVideo}},[_vm._v("Close")])])
}
var staticRenderFns = []

export { render, staticRenderFns }